module.exports = __webpack_public_path__ + "img/background10.54062a35.jpg";